import React from 'react';
import PageNavigation from './PageNavigation';
import './About.css';

function About() {
    return (
        <div className="about-page" lang="en">
            <PageNavigation />
            {/* Video Background */}
            <div className="about-video-container">
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="about-background-video"
                >
                    <source src="/rotb_big.mp4" type="video/mp4" />
                </video>
                <div className="about-video-overlay"></div>
            </div>

            {/* About Content */}
            <div className="about-container">
                <h1 className="about-title">ABOUT</h1>

                <div className="about-content">
                    <p className="about-paragraph">
                        Deep beneath the ordinary, where whispers of the past meet the pulse of rebellion, Return of the Basement is reborn. Born in the clandestine corridors of Kipdorp Antwerp's beloved student dorm, our legendary gatherings once defied the mundane—and the authorities. When the old space was silenced and its doors closed, a spark refused to be extinguished.
                    </p>

                    <p className="about-paragraph">
                        In a bold twist of fate, the spirit of those unforgettable nights found new life in an unexpected sanctuary: my own home. Here, brick by brick and beat by beat, we are transforming a humble basement into a realm where the past and future collide. Each phase of our metamorphosis is a step toward reclaiming a legacy—a promise that the magic will only grow stronger, more daring, and infinitely more captivating.
                    </p>

                    <p className="about-paragraph">
                        Step into the mystery. The allure of the underground beckons you to experience the evolution of a revolution. Return of the Basement isn't just a party—it's an invitation to be part of an ever-unfolding story, where every moment is a discovery and every beat carries the pulse of rebellion. Come and join us on this journey back to where it all began, and witness the resurrection of a legend.
                    </p>

                    {/* Credits */}
                    <div className="about-credits">
                        <h2 className="credits-title">[ CREDITS ]</h2>
                        <p className="about-paragraph credits-text">
                            No legend is written alone. Endless gratitude to Alec, Wout, Thijs and Lucas—the hands that carried speakers down narrow stairs, created the logo, built walls of silver, and kept the basement breathing long after midnight. They believed in this place before it had a name. ROTB is as much theirs as it is anyone's.
                        </p>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default About;
